module.exports = __webpack_public_path__ + "img/additional-info.a34394b8.png";